/**
 * StepTwo Component
 *
 * Features:
 * - Allows the user to assign a title to the activity.
 * - Uses i18next for translations.
 * - Utilizes Material-UI TextField for input.
 * - Communicates the title to the parent via activityTitleHandler prop.
 * - Uses CSS modules for styling.
 */
import { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import TextField from '@mui/material/TextField';

import classes from './StepTwo.module.css';

const StepTwo = props => {
  const { t } = useTranslation(['lesson']);
  // State to store the activity title entered by the user
  const [activityName, setActivityName] = useState();

  const handleChange = event => {
    setActivityName(event.target.value);
    props.activityTitleHandler(event.target.value);
  };

  return (
    <>
      <figure className={classes.stepNumber}>
        <img
          className={classes.numberImg}
          src="https://d1g6c01s9ssd7h.cloudfront.net/img/imageNumberActivity03.png"
          alt="number"
        />
      </figure>
      <p className={classes.titleActivity}>{t('assign_a_title')}</p>
      <TextField
        required
        className={classes.activityInput}
        onChange={handleChange}
        label={t('describe_your_task')}
        value={activityName}
      />
    </>
  );
};

StepTwo.propTypes = {
  /**
   * Function to handle the activity title change
   */
  activityTitleHandler: PropTypes.func
};

StepTwo.defaultProps = {
  activityTitleHandler: () => {}
};

export default StepTwo;
